/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS python filter api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GroundingConfigurationSchema,
  HTTPValidationError,
  PageConfigurationSchema,
} from '../models';
import {
    GroundingConfigurationSchemaFromJSON,
    GroundingConfigurationSchemaToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PageConfigurationSchemaFromJSON,
    PageConfigurationSchemaToJSON,
} from '../models';

export interface CreateConfigurationConfigurationsPostRequest {
    groundingConfigurationSchema: GroundingConfigurationSchema;
}

export interface DeleteConfigurationConfigurationsIdDeleteRequest {
    id: number;
}

export interface DisableConfigurationConfigurationsIdSetStatusPutRequest {
    id: number;
    disable: boolean;
}

export interface ReadConfigurationConfigurationsIdGetRequest {
    id: number;
}

export interface ReadConfigurationsConfigurationsGetRequest {
    onlyActive?: boolean | null;
    byUser?: string | null;
    page?: number;
    size?: number;
}

export interface UpdateConfigurationConfigurationsIdPutRequest {
    id: number;
    groundingConfigurationSchema: GroundingConfigurationSchema;
}

/**
 * 
 */
export class ConfigurationsApi extends runtime.BaseAPI {

    /**
     * Create a new Configuration. Args:     configuration_schema: The configuration to create.     db: The database session.     username: The username of the authenticated user. Returns:     Instance of the created Configuration.
     * Create Configuration
     */
    async createConfigurationConfigurationsPostRaw(requestParameters: CreateConfigurationConfigurationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroundingConfigurationSchema>> {
        if (requestParameters.groundingConfigurationSchema === null || requestParameters.groundingConfigurationSchema === undefined) {
            throw new runtime.RequiredError('groundingConfigurationSchema','Required parameter requestParameters.groundingConfigurationSchema was null or undefined when calling createConfigurationConfigurationsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/configurations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GroundingConfigurationSchemaToJSON(requestParameters.groundingConfigurationSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroundingConfigurationSchemaFromJSON(jsonValue));
    }

    /**
     * Create a new Configuration. Args:     configuration_schema: The configuration to create.     db: The database session.     username: The username of the authenticated user. Returns:     Instance of the created Configuration.
     * Create Configuration
     */
    async createConfigurationConfigurationsPost(requestParameters: CreateConfigurationConfigurationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroundingConfigurationSchema> {
        const response = await this.createConfigurationConfigurationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a configuration by ID. Args:     id: The ID of the configuration.
     * Delete Configuration
     */
    async deleteConfigurationConfigurationsIdDeleteRaw(requestParameters: DeleteConfigurationConfigurationsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteConfigurationConfigurationsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a configuration by ID. Args:     id: The ID of the configuration.
     * Delete Configuration
     */
    async deleteConfigurationConfigurationsIdDelete(requestParameters: DeleteConfigurationConfigurationsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteConfigurationConfigurationsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Disable a configuration by ID. Args:     id: The ID of the configuration.     disable: If True, disable the configuration. If False, enable the configuration.     db: The database session.     username: The username of the authenticated user.
     * Disable Configuration
     */
    async disableConfigurationConfigurationsIdSetStatusPutRaw(requestParameters: DisableConfigurationConfigurationsIdSetStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableConfigurationConfigurationsIdSetStatusPut.');
        }

        if (requestParameters.disable === null || requestParameters.disable === undefined) {
            throw new runtime.RequiredError('disable','Required parameter requestParameters.disable was null or undefined when calling disableConfigurationConfigurationsIdSetStatusPut.');
        }

        const queryParameters: any = {};

        if (requestParameters.disable !== undefined) {
            queryParameters['disable'] = requestParameters.disable;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/configurations/{id}/set_status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Disable a configuration by ID. Args:     id: The ID of the configuration.     disable: If True, disable the configuration. If False, enable the configuration.     db: The database session.     username: The username of the authenticated user.
     * Disable Configuration
     */
    async disableConfigurationConfigurationsIdSetStatusPut(requestParameters: DisableConfigurationConfigurationsIdSetStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.disableConfigurationConfigurationsIdSetStatusPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a single configuration by ID. Args:     id: The ID of the configuration.     db: The database session.     username: The username of the authenticated user. Returns:     Instance of the Configuration.
     * Read Configuration
     */
    async readConfigurationConfigurationsIdGetRaw(requestParameters: ReadConfigurationConfigurationsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroundingConfigurationSchema>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readConfigurationConfigurationsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroundingConfigurationSchemaFromJSON(jsonValue));
    }

    /**
     * Get a single configuration by ID. Args:     id: The ID of the configuration.     db: The database session.     username: The username of the authenticated user. Returns:     Instance of the Configuration.
     * Read Configuration
     */
    async readConfigurationConfigurationsIdGet(requestParameters: ReadConfigurationConfigurationsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroundingConfigurationSchema> {
        const response = await this.readConfigurationConfigurationsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all configurations for a user. Args:     db: The database session.     username: The username of the authenticated user.     only_active: Filter by active configurations.     by_user: Filter by user. Returns:     Paginated list of Configuration instances.
     * Read Configurations
     */
    async readConfigurationsConfigurationsGetRaw(requestParameters: ReadConfigurationsConfigurationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageConfigurationSchema>> {
        const queryParameters: any = {};

        if (requestParameters.onlyActive !== undefined) {
            queryParameters['only_active'] = requestParameters.onlyActive;
        }

        if (requestParameters.byUser !== undefined) {
            queryParameters['by_user'] = requestParameters.byUser;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/configurations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageConfigurationSchemaFromJSON(jsonValue));
    }

    /**
     * Get all configurations for a user. Args:     db: The database session.     username: The username of the authenticated user.     only_active: Filter by active configurations.     by_user: Filter by user. Returns:     Paginated list of Configuration instances.
     * Read Configurations
     */
    async readConfigurationsConfigurationsGet(requestParameters: ReadConfigurationsConfigurationsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageConfigurationSchema> {
        const response = await this.readConfigurationsConfigurationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a configuration by ID. Args:     id: The ID of the configuration.     configuration_schema: The configuration to update.     db: The database session.     username: The username of the authenticated user. Returns:     Instance of the updated Configuration.
     * Update Configuration
     */
    async updateConfigurationConfigurationsIdPutRaw(requestParameters: UpdateConfigurationConfigurationsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroundingConfigurationSchema>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateConfigurationConfigurationsIdPut.');
        }

        if (requestParameters.groundingConfigurationSchema === null || requestParameters.groundingConfigurationSchema === undefined) {
            throw new runtime.RequiredError('groundingConfigurationSchema','Required parameter requestParameters.groundingConfigurationSchema was null or undefined when calling updateConfigurationConfigurationsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GroundingConfigurationSchemaToJSON(requestParameters.groundingConfigurationSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroundingConfigurationSchemaFromJSON(jsonValue));
    }

    /**
     * Update a configuration by ID. Args:     id: The ID of the configuration.     configuration_schema: The configuration to update.     db: The database session.     username: The username of the authenticated user. Returns:     Instance of the updated Configuration.
     * Update Configuration
     */
    async updateConfigurationConfigurationsIdPut(requestParameters: UpdateConfigurationConfigurationsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroundingConfigurationSchema> {
        const response = await this.updateConfigurationConfigurationsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
